import type { FC } from "react";

import AllergiesModal from "@/components/modals/profil-health/allergies-modal";
import PathologiesModal from "@/components/modals/profil-health/pathologies-modal";
import WomenHealthModal from "@/components/modals/profil-health/women-health-modal";
import type { Patient } from "@/types/api/patient";

export type HealthUpdateModalProps = {
  healthModalOpen: "pathology" | "allergy" | "womenHealth" | "none";
  setHealthModalOpen: React.Dispatch<
    React.SetStateAction<"pathology" | "allergy" | "womenHealth" | "none">
  >;
  patient: Patient;
};

const HealthUpdateModal: FC<HealthUpdateModalProps> = ({
  healthModalOpen,
  setHealthModalOpen,
  patient,
}) => {
  switch (healthModalOpen) {
    case "pathology":
      return (
        <PathologiesModal
          healthModalOpen={healthModalOpen}
          setHealthModalOpen={setHealthModalOpen}
          patient={patient}
        />
      );
    case "allergy":
      return (
        <AllergiesModal
          healthModalOpen={healthModalOpen}
          setHealthModalOpen={setHealthModalOpen}
          patient={patient}
        />
      );
    case "womenHealth":
      return (
        <WomenHealthModal
          healthModalOpen={healthModalOpen}
          setHealthModalOpen={setHealthModalOpen}
          patient={patient}
        />
      );
    case "none":
      return null;
  }
};

export default HealthUpdateModal;
